var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',[_vm._v("404 Not Found")]),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v(" Home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }